import { render } from "./TwitchRedirect.vue?vue&type=template&id=227874eb&ts=true"
import script from "./TwitchRedirect.vue?vue&type=script&lang=ts"
export * from "./TwitchRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Documents\\Development\\juwie-giveaway\\juwie-giveaway-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__